<script>
import { mapGetters } from "vuex";
import { Icon } from "leaflet";
import { LMap, LTileLayer, LMarker } from "vue2-leaflet";

export default {
  components: {
    LMap,
    LTileLayer,
    LMarker,
  },

  data() {
    return {
      locationName: "",
      shapeStyle: {
        fillColor: "#ff0000",
        fillOpacity: 0.5,
        weight: 2,
        color: "#ff0000",
        opacity: 1,
      },

      url: "http://{s}.tile.osm.org/{z}/{x}/{y}.png",
      zoom: 15,
      center: [35.5, -95.5],
      bounds: null,
      drawOptions: null,
      drawnLayers: [],
    };
  },
  computed: {
    ...mapGetters("modal", ["getModalInfo"]),
    ...mapGetters("sites", ["getLong", "getLat"]),
  },

  mounted() {
    delete Icon.Default.prototype._getIconUrl;
    Icon.Default.mergeOptions({
      iconRetinaUrl: require("leaflet/dist/images/marker-icon-2x.png"),
      iconUrl: require("leaflet/dist/images/marker-icon.png"),
      shadowUrl: require("leaflet/dist/images/marker-shadow.png"),
    });

    const map = this.$refs.map.mapObject;
    setTimeout(() => {
      map.invalidateSize();
    }, 200);
    this.reverseGeocode();
  },
  methods: {
    reverseGeocode() {
      return new Promise((resolve, reject) => {
        fetch(
          `https://nominatim.openstreetmap.org/reverse?format=json&lat=${this.getLat}&lon=${this.getLong}`
        )
          .then((response) => response.json())
          .then((data) => {
            if (data.error) {
              this.$toast.error(
                "Unable to get the location, try with different coordinates.",
                {
                  position: "top-right",
                }
              );
            }
            const locationName = data.name ? data.name : data.display_name;
            resolve(locationName);
            this.locationName = locationName;
          })
          .catch((error) => {
            reject(error);
            this.$toast.error("Server is down, please try again later.", {
              position: "top-right",
            });
          });
      });
    },
    zoomUpdated(zoom) {
      console.log("zoom");
      this.zoom = zoom;
    },
    centerUpdated(center) {
      console.log("centerUpdated");
      this.center = center;
    },
    boundsUpdated(bounds) {
      this.bounds = bounds;
      console.log("bounds", this.bounds);
    },
    onDrawDeleted() {
      console.log("dddd");
    },
    onDrawCreated(event) {
      console.log("onDrawCreated", event);
      const layer = event.layer;
      const type = event.layerType; // Determine the type of shape drawn
      let coordinates = [];
      let radiusM = null;

      if (type === "circle") {
        const center = layer.getLatLng();
        radiusM = layer.getRadius();
        coordinates = [center.lat, center.lng];
      }

      // Now you have the coordinates of the drawn shape, you can use them as needed
      console.log("Drawn Coordinates:", coordinates);
      console.log("radius:", radiusM);
    },
  },
};
</script>

<template>
  <div class="site-details-wrapper">
    <div class="d-flex align-items-center justify-content-end modal-title-head">
      <div class="title-head">
        <p class="location-title-head">{{ $t('common.viewLocation') }}</p>
      </div>
      <svg
        @click="$bvModal.hide('dashboardLocations')"
        class="CloseLocation"
        width="22"
        height="22"
        viewBox="0 0 22 22"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M11 0C4.91333 0 0 4.91333 0 11C0 17.0867 4.91333 22 11 22C17.0867 22 22 17.0867 22 11C22 4.91333 17.0867 0 11 0ZM16.5978 14.7156C17.1111 15.2289 17.1111 16.06 16.5978 16.5733C16.3289 16.8422 16.0111 16.9644 15.6689 16.9644C15.3267 16.9644 14.9844 16.8422 14.74 16.5733L11.0733 12.9067L7.38222 16.5733C7.11333 16.8422 6.79556 16.9644 6.45333 16.9644C6.11111 16.9644 5.76889 16.8422 5.52444 16.5733C5.01111 16.06 5.01111 15.2289 5.52444 14.7156L9.21556 11.0244L5.52444 7.35778C5.01111 6.84444 5.01111 6.01333 5.52444 5.5C6.03778 4.98667 6.86889 4.98667 7.38222 5.5L11.0733 9.19111L14.7644 5.5C15.2778 4.98667 16.1089 4.98667 16.6222 5.5C17.1356 6.01333 17.1356 6.84444 16.6222 7.35778L12.9311 11.0489L16.5978 14.7156Z"
          fill="#F46A6A"
        />
      </svg>
    </div>

    <!-- <div :ref="mapContainer" style="width: 446px; height: 551px; border-radius: 21px; margin: auto"></div> -->

    <l-map
      ref="map"
      style="height: 551px; border-radius: 21px"
      :zoom="zoom"
      :center="[getLat, getLong]"
      @update:zoom="zoomUpdated"
      @update:center="centerUpdated"
      @update:bounds="boundsUpdated"
    >
      <l-tile-layer :url="url"></l-tile-layer>
      <l-marker :lat-lng="[getLat, getLong]"></l-marker>
      <div class="maps-lat-long d-flex">
        <div class="maps-lat-long d-flex">
          <div class="con-lat d-flex align-items-center justify-content-center">
            <div
              class="lat-map d-flex align-items-center justify-content-center"
            >
              <div class="map-value-one">{{ locationName }}</div>
            </div>
          </div>
        </div>
      </div>
    </l-map>
  </div>
</template>

<style lang="scss">
div#dashboardLocations {
  div#dashboardLocations___BV_modal_content_ {
    width: 492px !important;
    border-radius: 26px !important;
    div#dashboardLocations___BV_modal_body_ {
      padding-top: 40px !important;
      padding-inline-end: 22px !important;
      padding-bottom: 40px !important;
      padding-inline-start: 24px !important;

      .d-flex.align-items-center.justify-content-end.modal-title-head {
        margin-bottom: 40px;
        margin-inline-end: 18px;

        margin-inline-start: auto;
      }
      p.location-title-head {
        font-size: 16px;
        font-weight: 700;
        line-height: 20.4px;
        color: #000;
        margin-bottom: 0 !important;
        margin-inline-end: 132px;
      }
      .CloseLocation {
        cursor: pointer;
        margin-top: -5px;
      }
      .leaflet-container .leaflet-control-attribution {
        display: none !important;
      }

      .maps-lat-long.d-flex {
        position: absolute;
        top: 90%;
        width: 427px;
        justify-content: center;
        z-index: 9999999;
        .con-lat,
        .cont-long {
          background: #2680eb;
          color: #ffffff;
          font-size: 16px;
          line-height: 19px;
          font-weight: 400;
          height: auto;
          margin-inline-start: 16px;
          margin-inline-end: 16px;
          border-radius: 72px;
        }
        .lat-map {
          // max-width: 150px;
          padding-inline-end: 16px;
          padding-top: 3px;
          padding-bottom: 3px;
          padding-inline-start: 16px;
          //max-width: 519px;
        }
        .long-map {
          //max-width: 150px;
          padding-inline-end: 16px;
          padding-inline-start: 16px;
        }
        .map-value {
          //max-width: 85px!important;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          color: #ffffff;
          font-size: 16px;
          line-height: 19px;
          font-weight: 400;
          height: 27px;
          align-items: center;
          display: flex;
        }
        .map-value-one {
          word-break: break-all;
          color: #ffffff;
          font-size: 16px;
          line-height: 19px;
          font-weight: 400;
        }
      }
    }
  }
}
</style>
